import React from 'react';
import { TileType } from './tileEnums';
import Default from '../components/Tiles/Default';
import HealthChecklist from '../components/Tiles/HealthChecklist';
import InsuranceInsight from '../components/Tiles/InsuranceInsight';
import InsuranceProgress from '../components/Tiles/InsuranceProgress';
import CopayCoinsurance from '../components/Tiles/CopayCoinsurance';
import CopayCoinsuranceByService from '../components/Tiles/CopayCoinsuranceByService';
import CopayCoinsuranceByServiceComingSoon from '../components/Tiles/CopayCoinsuranceByServiceComingSoon';
import CopayCoinsuranceModal from '../components/Tiles/CopayCoinsuranceDetails';
import InsuranceSpendWidget from '../components/Tiles/InsuranceSpendWidget';

class TileFactory {
  static getTile = ({ tileIndex, tile, userProfile, eventName, extraProps }: any) => {
    const props = {
      tileIndex,
      tile,
      userProfile,
      eventName,
    };
    if (tile.allProps) Object.assign(props, extraProps);

    switch (tile.tileType) {
      case TileType.HEALTH_CHECKLIST:
        // @ts-expect-error ts-migrate(2604) FIXME: JSX element type 'HealthChecklist' does not have a... Remove this comment to see the full error message
        return <HealthChecklist {...props} />;

      case TileType.INSURANCE_INSIGHT:
        // @ts-expect-error ts-migrate(2604) FIXME: JSX element type 'InsuranceInsight' does not have ... Remove this comment to see the full error message
        return <InsuranceInsight {...props} />;

      case TileType.INSURANCE_PROGRESS:
        return <InsuranceProgress {...props} />;

      case TileType.COPAY_COINSURANCE:
        // @ts-expect-error ts-migrate(2604) FIXME: JSX element type 'CopayCoinsurance' does not have ... Remove this comment to see the full error message
        return <CopayCoinsurance {...props} />;

      case TileType.COPAY_COINSURANCE_BY_SERVICE:
        // @ts-expect-error ts-migrate(2604) FIXME: JSX element type 'CopayCoinsuranceByService' does ... Remove this comment to see the full error message
        return <CopayCoinsuranceByService {...props} />;

      case TileType.COPAY_COINSURANCE_BY_SERVICE_COMING_SOON:
        // @ts-expect-error ts-migrate(2604) FIXME: JSX element type 'CopayCoinsuranceByServiceComingS... Remove this comment to see the full error message
        return <CopayCoinsuranceByServiceComingSoon {...props} />;

      case TileType.COPAY_COINSURANCE_DETAILS_MODAL:
        return <CopayCoinsuranceModal {...props} />;

      case TileType.EMPTY:
        return null;

      case TileType.INSURANCE_SPEND_WIDGET:
        // @ts-expect-error ts-migrate(2604) FIXME: JSX element type 'InsuranceSpendWidget' does not h... Remove this comment to see the full error message
        return <InsuranceSpendWidget {...props} />;

      default:
        // @ts-expect-error ts-migrate(2604) FIXME: JSX element type 'Default' does not have any const... Remove this comment to see the full error message
        return <Default {...props} />;
    }
  };
}

export default TileFactory;
